import $ from 'jquery';

class cdpInsightProfilesWithBirthdayInNearestWeek{
  constructor() {
    if ($('#cdp-insight-profiles_with_birthday_in_nearest_week').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-insight-profiles_with_birthday_in_nearest_week').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    $('#cdp-insight-profiles_with_birthday_in_nearest_week .card-body .card-body h4').text(this.transform(response.profiles_count));
    $('#cdp-insight-profiles_with_birthday_in_nearest_week .card-body .card-text').html(`У <b>${this.transform(response.profiles_count)}</b>, (<b>${this.transform(response.profiles_percentage)}%</b>) участников день рождения состоится в ближайшую неделю, сохраните сегмент и поздравьте их. На всякий случай, мы исключили тех, кто недавно получал коммуникацию.`);
    $('#cdp-insight-profiles_with_birthday_in_nearest_week .peity-donut').text(`${response.profiles_percentage}/100`);
    $('#cdp-insight-profiles_with_birthday_in_nearest_week .peity-donut').peity('donut');
    this.loaded();
    this.toggleActionBtn(response.profiles_count);
  }

  toggleActionBtn(profiles_count){
    if (profiles_count > 0){
      $('#cdp-insight-profiles_with_birthday_in_nearest_week .open-new-insight-segment-modal').removeClass('d-none');
    } else {
      $('#cdp-insight-profiles_with_birthday_in_nearest_week .open-new-insight-segment-modal').addClass('d-none');
    }
  }

  loading(){
    $('#cdp-insight-profiles_with_birthday_in_nearest_week').addClass('loading');
  }

  loaded(){
    $('#cdp-insight-profiles_with_birthday_in_nearest_week').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpInsightProfilesWithBirthdayInNearestWeek;